/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

/**
 * Provides a utility which, given a CSV string, returns an array containing
 * each item.
 *
 * ```typescript
 *
 * import {fromCSV} from '@ion/core/utils';
 *
 * fromCSV('US');
 * ```
 */
export const fromCSV = (csv: string): string[] => {
  return csv.split(',').map(entry => entry.trim());
};
